import { useCallback, useEffect, useRef, useState } from "react";

import { Button } from "primereact/button";
import { Calendar } from "primereact/calendar";
import { Card } from "primereact/card";
import { Column } from "primereact/column";
import { confirmDialog } from "primereact/confirmdialog";
import { DataTable } from "primereact/datatable";
import { Dialog } from "primereact/dialog";
import { Dropdown } from "primereact/dropdown";
import { InputText } from "primereact/inputtext";
import { InputTextarea } from "primereact/inputtextarea";
import { Toast } from "primereact/toast";

import Loading from "../../../../components/Loading";
import Menu from "../../../../components/Menu";

import api from "../../../../services/api";

const initialState = {
    id: null,
    data_inicial: '',
    data_final: '',
    hora_inicial: '',
    hora_final: '',
    operador_id: '',
    parada_id: '',
    rolo_id: null,
    observacao: ''
}

export default function ParadaHistorico() {
    const [data, setData] = useState([]);
    const [form, setForm] = useState({...initialState});
    const [operadores, setOperadores] = useState([]);
    const [paradas, setParadas] = useState([]);

    const [initialDate, setInitialDate] = useState(new Date());
    const [finalDate, setFinalDate] = useState(new Date());

    const [isEditing, setIsEditing] = useState(false);
    const [isLoading, setIsLoading] = useState(false);
    const [isVisible, setIsVisible] = useState(false);

    const toast = useRef();

    const showError = (error) => toast.current.show({ summary: 'Ocorreu um Erro', severity: 'error', detail: error.response ? error.response.data.message : error.message });
    const showSuccess = (response) => toast.current.show({ summary: 'Sucesso', severity: 'success', detail: response.data.message });

    const fetchOperadores = useCallback(() => {
        api.get('operadores').then(response => {
            setOperadores(response.data);
        }).catch(error => {
            setOperadores([]);
        });
    }, []);

    const fetchParadas = useCallback(() => {
        api.get('acabamento/paradas').then(response => {
            setParadas(response.data);
        }).catch(error => {
            setParadas([]);
        });
    }, []);

    const handleDelete = (rowData) => {
        confirmDialog({
            acceptClassName: 'p-button-danger',
            acceptLabel: 'Excluir',
            rejectClassName: 'p-button-secondary',
            rejectLabel: 'Cancelar',
            header: 'Excluir',
            message: 'Você tem certeza que deseja excluir esse registro?',
            accept: () => {
                setIsLoading(true);
                api.delete(`acabamento/paradas-rolo/${rowData.id}/delete`).then(response => {
                    handleSearch();
                    setIsLoading(false);
                    showSuccess(response);
                }).catch(error => {
                    setIsLoading(false);
                    showError(error);
                });
            }
        });
    }

    const handleEdit = (rowData) => {
        let _form = {...rowData};

        _form.hora_inicial = _form.data_inicial.split(' ')[1];
        _form.hora_final = _form.data_final.split(' ')[1];

        _form.hora_inicial = _form.hora_inicial.substring(0, _form.hora_inicial.length - 3);
        _form.hora_final = _form.hora_final.substring(0, _form.hora_final.length - 3);

        _form.data_inicial = new Date(_form.data_inicial.split(' ')[0].replace('-', '/'));
        _form.data_final = new Date(_form.data_final.split(' ')[0].replace('-', '/'));

        setForm(_form);
        setIsEditing(true);
        setIsVisible(true);
    }
    
    const handleSearch = () => {
        if(!initialDate || !finalDate) {
            toast.current.show({ summary: 'Aviso', severity: 'warn', detail: 'Preencha as datas corretamente para pesquisar!' });
            return;
        }
        
        let date1 = initialDate.getFullYear().toString() + "-" + (initialDate.getMonth() + 1).toString().padStart(2, '0') + '-' + initialDate.getDate().toString().padStart(2, '0');
        let date2 = finalDate.getFullYear().toString() + "-" + (finalDate.getMonth() + 1).toString().padStart(2, '0') + '-' + finalDate.getDate().toString().padStart(2, '0');

        setIsLoading(true);
        api.get('acabamento/paradas-rolo/historico', {
            params: {
                data_inicial: date1,
                data_final: date2
            }
        }).then((response) => {
            setData(response.data);
            setIsLoading(false);
        }).catch((error) => {
            setData([]);
            setIsLoading(false);
        });
    }

    const handleSubmit = () => {
        if(!form.data_inicial || !form.data_final || !form.hora_inicial || !form.hora_final) {
            toast.current.show({ summary: "Aviso", severity: "warn", detail: "Preencha os campos de data/hora corretamente!" });
            return;
        }

        let data_inicial = form.data_inicial;
        let data_final = form.data_final;

        data_inicial.setHours(0, 0, 0, 0);
        data_final.setHours(0, 0, 0, 0);

        if(data_final < data_inicial) {
            toast.current.show({ summary: "Aviso", severity: "warn", detail: "Data Inicial não pode ser maior que a Data Final." });
            return;
        }

        if(data_inicial.getTime() === data_final.getTime()) {
            if(Date.parse(`1/1/1999 ${form.hora_final}:00`) <= Date.parse(`1/1/1999 ${form.hora_inicial}:00`)) {
                toast.current.show({ summary: "Aviso", severity: "warn", detail: "Hora Inicial não pode ser maior ou igual que a Hora Final." });
                return;
            }
        }

        data_inicial = String(data_inicial.getDate()).padStart(2, '0') + "/" + String(data_inicial.getMonth() + 1).padStart(2, '0') + "/"
        + data_inicial.getFullYear() + ' ' + form.hora_inicial + ':00';
            
        data_final = String(data_final.getDate()).padStart(2, '0') + "/" + String(data_final.getMonth() + 1).padStart(2, '0') + "/"
            + data_final.getFullYear() + ' ' + form.hora_final + ':00';

        let _form = { ...form };
        _form.data_inicial = data_inicial;
        _form.data_final = data_final;

        setIsLoading(true);
        if(isEditing && form.id !== null) {
            api.put(`acabamento/paradas-rolo/${form.id}/update`, _form).then((response) => {
                handleSearch();
                setIsEditing(false);
                setIsLoading(false);
                setIsVisible(false);
                setForm({...initialState});
                showSuccess(response);
            }).catch((error) => {
                setIsLoading(false);
                showError(error);
            });
        } else {
            api.post(`acabamento/paradas-rolo`, _form).then((response) => {
                handleSearch();
                setIsLoading(false);
                setIsVisible(false);
                setForm({...initialState});
                showSuccess(response);
            }).catch((error) => {
                setIsLoading(false);
                showError(error);
            });
        }
    }

    const onHide = () => {
        setForm({...initialState});
        setIsVisible(false);
    }

    useEffect(() => {
        fetchOperadores();
        fetchParadas();
    }, [fetchOperadores, fetchParadas]);

    if(isLoading)
        return <Loading />

    return (
        <div>
            <Menu />
            <Toast ref={toast} />

            <Card
                className="p-m-1"
                title="Histórico de Paradas"
            >
                <div className="p-d-flex p-flex-row p-jc-between">
                    <div>
                        <Calendar 
                            className="p-m-1"
                            dateFormat="dd/mm/yy"
                            mask="99/99/9999"
                            onChange={e => setInitialDate(e.value)}
                            placeholder="Data Inicial"
                            value={initialDate}
                        />

                        <Calendar 
                            className="p-m-1"
                            dateFormat="dd/mm/yy"
                            mask="99/99/9999"
                            onChange={e => setFinalDate(e.value)}
                            placeholder="Data Final"
                            value={finalDate}
                        />

                        <Button 
                            className="p-button-success p-m-1"
                            icon="pi pi-search"
                            onClick={handleSearch}
                            title="Clique para fazer uma pesquisa entre datas"
                        />
                    </div>
                    <div>
                        <Button 
                            className="p-button-primary p-m-1"
                            icon="pi pi-plus"
                            onClick={() => {
                                setIsVisible(true);
                            }}
                        />
                    </div>
                </div>

                <Dialog
                    footer={() => (
                        <div>
                            <Button 
                                className="p-button-secondary"
                                label="Cancelar"
                                onClick={onHide}
                            />

                            <Button 
                                className="p-button-success"
                                label="Salvar"
                                onClick={handleSubmit}
                            />
                        </div>
                    )}
                    header={isEditing ? "Editar Registro" : "Cadastrar Parada"}
                    onHide={onHide}
                    style={{ minWidth: '50vw' }}
                    visible={isVisible}
                >
                    <div className="p-fluid">
                        <div className="p-field">
                            <label htmlFor="operador_id">Operador: </label>
                            <Dropdown 
                                filter
                                onChange={e => setForm({...form, operador_id: e.value })}
                                options={operadores}
                                optionLabel="nome"
                                optionValue="idoperador"
                                value={form.operador_id}
                            />
                        </div>
                        <div className="p-field">
                            <label htmlFor="parada_id">Parada: </label>
                            <Dropdown
                                filter
                                onChange={e => setForm({...form, parada_id: e.value })}
                                options={paradas}
                                optionLabel="descricao"
                                optionValue="id"
                                value={form.parada_id}
                            />
                        </div>
                        <div className="p-fluid">
                            <div className="p-field">
                                <label htmlFor="data_inicial">Data Inicial: </label>
                                <Calendar 
                                    dateFormat="dd/mm/yy"
                                    mask="99/99/9999"
                                    onChange={e => setForm({...form, data_inicial: e.value })}
                                    value={form.data_inicial}
                                />
                            </div>
                            <div className="p-field">
                                <InputText 
                                    onChange={e => setForm({...form, hora_inicial: e.target.value })}
                                    type="time"
                                    value={form.hora_inicial}
                                />
                            </div>
                        </div>
                        <div className="p-fluid">
                            <div className="p-field">
                                <label htmlFor="data_final">Data Final: </label>
                                <Calendar 
                                    dateFormat="dd/mm/yy"
                                    mask="99/99/9999"
                                    onChange={e => setForm({...form, data_final: e.value })}
                                    value={form.data_final}
                                />
                            </div>
                            <div className="p-field">
                                <InputText 
                                    onChange={e => setForm({...form, hora_final: e.target.value })}
                                    type="time"
                                    value={form.hora_final}
                                />
                            </div>
                        </div>
                        <div className="p-field">
                            <label htmlFor="observacao">Observação: </label>
                            <InputTextarea 
                                onChange={e => setForm({...form, observacao: e.target.value })}
                                placeholder="..."
                                value={form.observacao}
                            />
                        </div>
                    </div>
                </Dialog>

                <DataTable
                    emptyMessage="Nenhum registro encontrado."
                    responsiveLayout="scroll"
                    size="small"
                    value={data}
                >
                    <Column header="ID" field="id" />
                    <Column header="Nº Rolo" field="nomerolo" />
                    <Column header="Operador" field="operador" />
                    <Column header="Parada" field="parada" />
                    <Column header="Data Inicial" field="datainicial" />
                    <Column header="Data Final" field="datafinal" />
                    <Column header="min" field="tempomin" />
                    <Column header="Observação" field="observacao" style={{ fontSize: 11 }} />
                    <Column header="Ações" body={(rowData) => (
                        <div>
                            <Button 
                                className="p-button-primary p-mr-2"
                                icon="pi pi-pencil"
                                onClick={() => handleEdit(rowData)}
                                title="Clique para editar o registro"
                            />
                            <Button 
                                className="p-button-danger p-mr-2"
                                icon="pi pi-trash"
                                onClick={() => handleDelete(rowData)}
                                title="Clique para excluir o registro"
                            />
                        </div>
                    )} />
                </DataTable>
            </Card>
        </div>
    )
}